import React from 'react';
import CustomizedTooltipPresenter from './CustomizedTooltipPresenter';
import { CustomizedTooltipProps } from './types';

/**
 * @param title string | ReactNode
 * @param variant default | paper
 * @param closeButton boolean (defaultValue = false)
 * @param zIndex number (default 500)
 * @param ClickAwayListener boolean
 * @param gutter number
 */
const CustomizedTooltipContainer: React.FC<CustomizedTooltipProps> = (
  props
) => {
  return <CustomizedTooltipPresenter {...props} />;
};

export default CustomizedTooltipContainer;
